import { DocumentRadioCertificate } from 'front-office/constants/document-radio-certificate';
import { ElectoralFormVM } from 'front-office/view-models/electoral/electoral-form';
import { DateTime } from 'luxon';
import { HistoricalRequestCertificate } from 'shell/models/request-certificate-historical';

export const transformRequestElectoralData = (
  values: ElectoralFormVM
): HistoricalRequestCertificate => {
  const hasDataApplicantObject =
    values.applicant?.fiscalCode ||
    values.applicant?.name ||
    values.applicant?.surname ||
    values.applicant?.withoutName ||
    values.applicant?.withoutSurname ||
    values.applicant?.gender;

  const hasBirthdayPlace =
    values.generality?.municipalityOfBirth || values.generality?.foreignStateBirth;

  const hasDataGeneralityObject =
    values.generality?.idSubjectAnpr || values.generality?.birthDate || hasBirthdayPlace;

  const generalitaRichiedente =
    hasDataApplicantObject || hasDataGeneralityObject
      ? {
          idSchedaSoggettoANPR: values.generality?.idSubjectAnpr || undefined,
          codiceFiscale: values.applicant?.fiscalCode
            ? {
                codFiscale: values.applicant?.fiscalCode,
              }
            : undefined,
          nome: values.applicant?.name,
          cognome: values.applicant?.surname,
          senzaNome: values.applicant?.withoutName ? '1' : undefined,
          senzaCognome: values.applicant?.withoutSurname ? '1' : undefined,
          sesso: values.applicant?.gender,
          dataNascita: values.generality?.birthDate?.toFormat('yyyy-MM-dd'),
          senzaGiorno:
            !values.generality?.birthChoiceDate?.includes('day') &&
            values.generality?.birthChoiceDate?.includes('month')
              ? '1'
              : undefined,
          senzaGiornoMese:
            !values.generality?.birthChoiceDate?.includes('day') &&
            !values.generality?.birthChoiceDate?.includes('month') &&
            values.generality?.birthDate
              ? '1'
              : undefined,
          luogoNascita: hasBirthdayPlace
            ? {
                comune:
                  !values.generality?.isForeign && values.generality?.municipalityOfBirth
                    ? {
                        nomeComune: values.generality?.municipalityOfBirth?.description,
                        siglaProvinciaIstat: values.generality?.municipalityOfBirth?.province,
                        descrizioneLocalita: values.generality?.locality,
                      }
                    : undefined,
                localita:
                  values.generality?.isForeign && values.generality?.foreignStateBirth
                    ? {
                        codiceStato: values.generality?.foreignStateBirth?.id,
                        descrizioneStato: values.generality?.foreignStateBirth?.value,
                        provinciaContea: values.generality?.foreignStateBirth?.province,
                        descrizioneLocalita: values.generality?.foreignMunicipality?.description,
                      }
                    : undefined,
              }
            : undefined,
        }
      : undefined;

  return {
    generalitaRichiedente,
    usoInterno: values?.certificateInternOnly,
    motivoRilascio: values.accountholder?.account?.applicant?.releaseReason || undefined,
    intestatario: values.accountholder?.sameApplicant
      ? undefined
      : values.accountholder?.account?.applicant?.fiscalCode,
    nomeIntestatario: values.accountholder?.sameApplicant
      ? undefined
      : values.accountholder?.account?.applicant?.name,
    cognomeIntestatario: values.accountholder?.sameApplicant
      ? undefined
      : values.accountholder?.account?.applicant?.surname,
    tipoDocumento: values.electoral,
    dataRiferimento:
      values.dateForm?.toFormat('yyyy-MM-dd') || DateTime.now().toFormat('yyyy-MM-dd'),
    // modalita rilascio
    codiceModalitaRilascio: values.modality?.id as string,
    tipoPagamento: values.typePayment,
    forzaCertificato: values.withReports,
    destinazioneUso: values.intendedUse,
    cartaIdentita:
      values.generality?.numberDocument ||
      values.generality?.dateReleaseDocument ||
      values.generality?.municipalityDocument ||
      values.generality?.consulateCode
        ? {
            numero: values.generality?.numberDocument,
            dataRilascio: values.generality?.dateReleaseDocument?.toFormat('yyyy-MM-dd'),
            comuneRilascio:
              values.generality?.isForeignDocument === DocumentRadioCertificate.IdentityCard
                ? {
                    codiceIstat: values.generality?.municipalityDocument?.id || '',
                    nomeComune: values.generality?.municipalityDocument?.description || '',
                    siglaProvinciaIstat: values.generality?.municipalityDocument?.province || '',
                  }
                : undefined,
            consolatoRilascio:
              values.generality?.isForeignDocument === DocumentRadioCertificate.Other
                ? {
                    descrizioneConsolato: values.generality?.consulateCode || '',
                  }
                : undefined,
          }
        : undefined,
  };
};
